<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit="reset">
                  <h1>Alterar senha</h1>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Senha" autocomplete="current-password" v-model="password" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Confirmação da senha" autocomplete="current-password" v-model="passwordConfirmation" />
                    <b-form-text>
                      A senha não pode ser similar ao seu nome ou email. <br>
                      A senha deve ter pelo menos 8 dígitos. <br>
                      A senha deve conter pelo menos 1 letra. <br>
                      A senha deve conter pelo menos 1 número. <br>
                    </b-form-text>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" class="px-4" type="submit">Enviar</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <div class="card text-white py-5 d-md-down-none" style="width:44%">
              <div class="card-body text-center">
                <img src="/assets/img/logo.jpg" alt="" width="100%" style="padding-top:8%">
              </div>
            </div>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Login',
  data() {
    return {
      password: '',
      passwordConfirmation: '',
    }
  },
  methods: {
    reset(e) {
      if (this.password != this.passwordConfirmation) {
        this.$swal.fire({
          title: 'Senhas não coincidem.',
          type: 'error',
        });
        return;
      }

      if (!e.target.checkValidity()) {
        return;
      }

      e.preventDefault();

      this.$store.dispatch('auth/changePassword', {
        password: this.password,
        token: this.$route.params.token,
        success: (response) => {
          if (response.data.status === 500 || response.data.status === 900) {
            this.$swal.fire({
              title: 'Aviso',
              text: response.data.message,
              type: 'error',
            });
            return
          }
          this.$swal.fire({
            title: 'Aviso',
            text: 'Senha alterada com sucesso.',
            type: 'success',
          }).then(() => {
            this.$router.push('/account/login');
          });
        },
        error: () => {
          this.$swal.fire({
            title: 'Aviso',
            text: 'Houve um erro, tente novamente!',
            type: 'error',
          });
        }
      });
    }
  },
}

</script>
